export function SupportPage() {
  return (
    <div className="kt-prose">
      <h1 className="ab-h1" style={{ color: "var(--kt-ink)" }}>Support</h1>

      <section>
        <h2 className="ab-h2" style={{ color: "var(--kt-ink)" }}>Get help</h2>
        <p>
          For questions, bug reports, or feature requests, email us directly.
        </p>
      </section>

      <section>
        <h2 className="ab-h2" style={{ color: "var(--kt-ink)" }}>Email</h2>
        <p>
          <a href="mailto:hello@example.com" style={{ color: "var(--kt-teal-ink)" }}>
            hello@example.com
          </a>
        </p>
      </section>
    </div>
  );
}
